import { tabTaxProfiles } from "./tab-tax-profiles";
import { tabTaxGroups } from "./tab-tax-groups";
import { tabTaxCouvert } from "./tab-tax-couvert";

export const taxTabs = {
	tabTaxCouvert,
	tabTaxGroups,
	tabTaxProfiles,
};
